
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRoleManagement } from "./role-management/useRoleManagement";
import UsersList from "./role-management/UsersList";
import AddRoleDialog from "./role-management/AddRoleDialog";
import AssignIntegrationsManagerRole from "./role-management/AssignIntegrationsManagerRole";

const RoleManagement = () => {
  const {
    users,
    isLoading,
    fetchUsers,
    selectedUser,
    isDialogOpen,
    setIsDialogOpen,
    newRole,
    setNewRole,
    handleAddRole,
    handleRemoveRole,
    openAddRoleDialog
  } = useRoleManagement();

  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Funções de Usuários</CardTitle>
        <CardDescription>
          Gerencie funções e permissões de usuários
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="border p-4 rounded-md mb-6 bg-gray-50">
          <h3 className="text-sm font-medium mb-2">Ações Rápidas</h3>
          <AssignIntegrationsManagerRole />
        </div>
        
        <Button
          onClick={fetchUsers}
          disabled={isLoading}
          className="mb-4"
        >
          {isLoading ? "Carregando..." : "Carregar Usuários e Funções"}
        </Button>
        
        <UsersList 
          users={users} 
          onAddRole={openAddRoleDialog} 
          onRemoveRole={handleRemoveRole} 
        />
      </CardContent>
      
      <AddRoleDialog 
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        selectedUser={selectedUser}
        onAddRole={handleAddRole}
        newRole={newRole}
        onRoleChange={setNewRole}
      />
    </Card>
  );
};

export default RoleManagement;
